import { useEffect, useState } from "react";
import Api from "../openapi";
import { AccountTransactionResponse } from "../openapi/client";
import { checkIf } from "../utils";

export default function usePaymentHistory(accountId?: string, refresh?: number) {
  const [paymentHistory, setPaymentHistory] = useState<AccountTransactionResponse[]>([]);

  useEffect(() => {
    const getPaymentHistory = async () => {
      try {
        const res = await Api.Account.listTransactions(String(accountId));
        setPaymentHistory(res.data);
      } catch (error) {}
    };
    if (checkIf(accountId)) {
      getPaymentHistory();
    }
  }, [accountId, refresh]);
  return paymentHistory;
}
